var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "20 0 10 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    fillOpacity: 0.5,
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    fillOpacity: 0.8,
    d: "M0 0h6v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "svg-path3",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.688 25.713a2.779 2.779 0 0 1-2.783-2.769 2.779 2.779 0 0 1 2.782-2.77 2.78 2.78 0 0 1 2.783 2.77 2.78 2.78 0 0 1-2.782 2.77m-9.375 0a2.779 2.779 0 0 1-2.783-2.77 2.779 2.779 0 0 1 2.782-2.77 2.78 2.78 0 0 1 2.783 2.77 2.78 2.78 0 0 1-2.783 2.77m11.6.492a3.937 3.937 0 0 0 1.739-3.262c0-2.175-1.778-3.944-3.964-3.944-2.185 0-3.963 1.77-3.963 3.944 0 1.355.69 2.551 1.739 3.262A5.345 5.345 0 0 0 25 28.523a5.343 5.343 0 0 0-2.463-2.317 3.937 3.937 0 0 0 1.739-3.262c0-2.175-1.778-3.944-3.964-3.944-2.185 0-3.963 1.77-3.963 3.944 0 1.355.69 2.551 1.739 3.262C16.268 27.046 15 28.876 15 31h1.18c0-2.267 1.854-4.112 4.132-4.112a4.129 4.129 0 0 1 4.094 3.577c-.019.176-.031.354-.031.535H25.625c0-.181-.012-.359-.03-.535a4.128 4.128 0 0 1 4.092-3.577c2.279 0 4.133 1.845 4.133 4.112H35c0-2.124-1.268-3.954-3.087-4.794"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.de81450722d4c447bfd0977b982f67df.svg";
export { ForwardRef as ReactComponent };